<h2 mat-dialog-title>Linking Patreon...</h2>
<mat-dialog-content>
    <div style="display: flex; justify-content: center; align-items: center; gap: 50px; margin: 2rem 0 3rem 0">
        <img src="/img/jar.png" alt="Jar" style="width: 100px; height: 100px;">
        <mat-spinner style="height: 50px;"></mat-spinner>
        
        <picture>
            <source srcset="/img/patreon_icon_dark.svg" media="(prefers-color-scheme: dark)">
            <img src="/img/patreon_icon.svg" alt="Patreon" style="width: 100px; height: 100px;">
        </picture>
    </div>
    <p>We're linking your Patreon account to your account, please wait...</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button style="width: fit-content;" mat-button (click)="forceFail()">Cancel</button>
</mat-dialog-actions>